import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import moment from "moment";
import {inject, onMounted, ref} from "vue";
import {AxiosStatic} from "axios";
import Button from "primevue/button";

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ListRequisitionTable',
  setup(__props, { expose }) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const requisitions = ref<any[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)

// Define lifecycle hooks
onMounted(() => {
  loadData()
})


// Define methods
function formatTimestamp(input: string): string {
  return moment(input).format('DD.MM.YYYY')
}

function processDownload(input: any) {
  console.log(input)
  axios?.get(`/requisition/${input.id}/content`, {
    responseType: 'blob'
  }).then(response => {
    const objectURL = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = objectURL
    link.setAttribute('download', `${input.documentName}.pdf`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(link.href)

  })

}

function loadData(filterData: any = {}) {
  loading.value = true
  axios?.get("/requisition")
      .then((response) => {
        if (response.status === 200) {
          requisitions.value = response.data
        }
        totalRecords.value = response.data.length
        loading.value = false
      }).catch(error => {
    console.error('Can not load requisition', error)
    loading.value = false
  })
}

function reload() {
  loadData()
}

expose({reload})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    rowHover: true,
    page: pageIndex.value+1,
    ref_key: "dt",
    ref: dt,
    dataKey: "id",
    value: requisitions.value,
    paginator: true,
    rows: pageSize.value,
    totalRecords: totalRecords.value,
    filterDisplay: "row",
    loading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "id",
        header: "ID"
      }),
      _createVNode(_unref(Column), {
        field: "companyName",
        header: "COMPANY NAME",
        filterMatchMode: "startsWith",
        ref: "companyName"
      }, null, 512),
      _createVNode(_unref(Column), {
        field: "startDate",
        header: "Platne od"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(formatTimestamp(data.startDate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "endDate",
        header: "Termin dokonceni"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(formatTimestamp(data.endDate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "note",
        header: "NOTE"
      }),
      _createVNode(_unref(Column), {
        field: "documentName",
        header: "DOCUMENT"
      }),
      _createVNode(_unref(Column), { header: "Stáhnout" }, {
        body: _withCtx(({data}) => [
          _createVNode(_unref(Button), {
            icon: "pi pi-download",
            type: "button",
            label: "Download",
            onClick: ($event: any) => (processDownload(data))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["page", "value", "rows", "totalRecords", "loading"]))
}
}

})